export default "__VITE_ASSET__CnFq6dso__"